import { useTranslation } from 'react-i18next';
import { KoobButton } from '@koob/ui';
import {
  FolderAddServiceMenu,
  FolderArchiveButton,
  FolderHeader,
  FolderLanguageBadge,
  FolderReadOnlyTooltip,
} from '@koob/booking';
import { canCancelAllFolderBookings } from '@koob/utils';
import KoobBackButton from '../../../components/Koob/KoobBackButton';
import CancelAllBookings from './CancelAllBookings';

/**
 * TO action bar of a client folder (KD-3842), assembled from the shared
 * folder bricks. An archived folder is read-only.
 */
export default function FoldersDetailsHeader({
  folder,
  language,
  canDesignTrip,
  onEditDetails,
  onArchive,
  onUnarchive,
  onAddHotel,
  onAddExperience,
  onDesignTrip,
  reload,
}) {
  const { t } = useTranslation('folders');
  const archived = Boolean(folder?.archivedAt);

  return (
    <FolderHeader
      folder={folder}
      fallbackTitle={t('details.screenTitle')}
      backButton={<KoobBackButton />}
      titleAddon={
        folder?.locale && (
          <FolderLanguageBadge
            label={language?.title ?? folder.locale.toUpperCase()}
            flag={language?.description}
          />
        )
      }
    >
      <FolderReadOnlyTooltip readOnly={archived}>
        <KoobButton
          variant="secondary"
          onClick={onEditDetails}
          disabled={archived}
          data-testid="folder-edit-details"
        >
          {t('actions.editDetails')}
        </KoobButton>
      </FolderReadOnlyTooltip>

      <FolderArchiveButton
        folder={folder}
        onArchive={onArchive}
        onUnarchive={onUnarchive}
      />

      {canCancelAllFolderBookings(folder) && (
        <CancelAllBookings
          folderId={folder.id}
          bookings={folder.bookings ?? []}
          reload={reload}
        />
      )}

      <span className="mx-1 h-[26px] w-px bg-gray-200" aria-hidden="true" />

      <FolderReadOnlyTooltip readOnly={archived}>
        <FolderAddServiceMenu
          onAddHotel={onAddHotel}
          onAddExperience={onAddExperience}
          disabled={archived}
        />
      </FolderReadOnlyTooltip>

      {canDesignTrip && (
        <FolderReadOnlyTooltip readOnly={archived}>
          <KoobButton
            variant="primary"
            onClick={onDesignTrip}
            disabled={archived}
            data-testid="folder-design-trip"
          >
            {t('actions.designTrip')}
          </KoobButton>
        </FolderReadOnlyTooltip>
      )}
    </FolderHeader>
  );
}
